import {Component} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {WelcomeApiService} from "../../../core/api/welcome-api.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";
import {SettingsService} from "../../service/settings.service";


@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent extends CoreComponent {

  privacyPolicy: string | undefined;

  constructor(
    protected settingService: SettingsService,
    protected router: Router,
    protected welcomeApiService: WelcomeApiService,
    protected messageService: AppMessageService,
    protected formBuilder: FormBuilder,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.settingService.setHeader('Datenschutz', 'Was mit Deinen Daten passiert – einfach erklärt.');
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.getPrivacyPolicy();
    this.refreshComponent();
  }

  getPrivacyPolicy() {
    this.welcomeApiService.getPrivacyPolicy().subscribe(res => {
      this.privacyPolicy = res.replace(/&nbsp;/g, ' ');
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

}
